export default "__VITE_ASSET__DrCdf55j__"